import React from 'react';
import Variation from '../../../base/Variation';
import { MOCK_UP_VARIATION_LAYER } from '../../../../propTypes';
import {
    DEFAULT_MIX_BLEND_MODE,
    DEFAULT_OPACITY,
    DEFAULT_VARIATION_BACKGROUND,
    DEFAULT_Z_INDEX,
} from '../../constants';
import './index.scss';

export const VariationLayer = ({
    zIndex = DEFAULT_Z_INDEX,
    mixBlendMode = DEFAULT_MIX_BLEND_MODE,
    opacity = DEFAULT_OPACITY,
    background = DEFAULT_VARIATION_BACKGROUND,
    transparentBackground = false,
    variation,
    transform,
    visible = false,
}) => (
    <div style={{ zIndex, transform, mixBlendMode, opacity }} className="variation-layer layer">
        {visible && (
            <Variation
                {...variation}
                backgroundColor={transparentBackground ? DEFAULT_VARIATION_BACKGROUND : background}
            />
        )}
    </div>
);

VariationLayer.propTypes = MOCK_UP_VARIATION_LAYER;
